import { getAncestors } from "./getAncestors";

export { getAncestors as getParents };
